var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-8 -6 38 36",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12c0-4.9706-4.0294-9-9-9-4.9706 0-9 4.0294-9 9 0 1.1971.2337 2.3397.6581 3.3845.0812.2.1218.3.1399.3808.0177.079.0242.1375.0242.2186 0 .0828-.015.173-.0451.3535l-.593 3.5578c-.0621.3726-.0932.5589-.0354.6936.0506.1179.1445.2119.2624.2624.1347.0578.321.0268.6936-.0353l3.5579-.593c.1804-.0301.2706-.0451.3535-.0451.081 0 .1395.0065.2186.0242.0808.0181.1808.0587.3808.1399C9.6603 20.7663 10.8029 21 12 21c4.9706 0 9-4.0294 9-9ZM12 4.5c4.25 0 7.5 3.25 7.5 7.5s-3.25 7.5-7.5 7.5c-1 0-2.5-.5-3-.8-.2-.08-.3-.12-.4-.15-.2-.06-.4-.08-.6-.05L5 19l.5-3c.03-.2.01-.4-.05-.6-.03-.1-.07-.2-.15-.4-.3-.5-.8-2-.8-3 0-4.25 3.25-7.5 7.5-7.5Zm2 4.75H8.5a.875.875 0 000 1.75H14a.875.875 0 000-1.75ZM16 13H8a.875.875 0 000 1.75h8A.875.875 0 0016 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon--comment.c4f9d5b7a05ee93bcf621451fbd3b4fe.svg";
export { ForwardRef as ReactComponent };